import { render, staticRenderFns } from "./SalesRecapNew.vue?vue&type=template&id=ca02c850&"
import script from "./SalesRecapNew.vue?vue&type=script&lang=js&"
export * from "./SalesRecapNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports